import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {RootState} from '../rootReducer';

export type AppState = {
  isSideDrawerOpen: boolean;
};

const initialAppState: AppState = {
  isSideDrawerOpen: true,
};

export const appSlice = createSlice({
  name: 'app',
  initialState: initialAppState,
  reducers: {
    onSetSideDrawerOpen(state, action: PayloadAction<boolean>) {
      state.isSideDrawerOpen = action.payload;
    },
  },
});

export const appReducer = appSlice.reducer;
export const appActions = appSlice.actions;

export const appSelectors = {
  getSideDrawerOpen: (state: RootState) => state.app.isSideDrawerOpen,
};
